var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "url(#paint0_linear_1959_75649)",
    stroke: "#D5DDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 17.1277L9.14748 14.5252C8.85498 14.2327 8.38248 14.2327 8.08998 14.5252C7.79748 14.8177 7.79748 15.2902 8.08998 15.5827L11.225 18.7177C11.5175 19.0102 11.99 19.0102 12.2825 18.7177L20.2175 10.7827C20.51 10.4902 20.51 10.0177 20.2175 9.72523C19.925 9.43273 19.4525 9.43273 19.16 9.72523L11.75 17.1277Z",
    fill: "#8291AE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1959_75649",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 2.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/check_mark_icon.49fa3dfe0364ccfdf4a805170d1ffaf6.svg";
export { ForwardRef as ReactComponent };